<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="分类">
                            <c-select name="category_id" async v-model="categoryId" @search="searchCategory"></c-select>
                        </m-search-item>
                        <m-search-item label="品牌">
                            <c-select name="brand_id" async v-model="brandId" @search="searchBrand"></c-select>
                        </m-search-item>
                        <m-search-item label="型号">
                            <c-select name="spu_model_id" async  @search="searchModel"></c-select>
                        </m-search-item>
                        <m-search-item label="所属部门">
                            <c-select name="handover_dept_id" async  @search="searchDepartment"></c-select>
                        </m-search-item>
                        <m-search-item label="当前接驳人">
                            <c-input name="handover_user_name"></c-input>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button v-if="auth('b_storage_stay_duration_export')" prepend-icon="tf-export"
                              @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #produce_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>
                <!--等级-->
                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>
                <!--背贴码主状态-->
                <template #main_state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_MAIN_STATE" :value="data.main_state"></c-state>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <template #stay_days="{data}">
                    {{data.stay_days}} 天
                </template>
                <template #current_stay_days="{data}">
                    {{data.current_stay_days}} 天
                </template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import MProductInfo from "../../components/module/product_info.vue";

export default {
    name: 'm_storage_stay_duration',
    components: {MProductInfo},

    computed: {
        ...mapState(['saasInfo', 'userInfo'])
    },

    data() {
        return {
            categoryId:'',
            brandId:'',
            defaultSearchData: {
            },
            workType: 26                   //设备停留时长
        }
    },
    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*******搜索分类*****************/
        searchCategory(keyword, resolve){
            this.request({
                url:'/spu/category/options',
                data: {
                    keyword: keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*******搜索品牌*****************/
        searchBrand(keyword, resolve){
            this.request({
                url:'/spu/brand/options',
                data: {
                    category_id: this.categoryId,
                    keyword: keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*******搜索机型****************/
        searchModel(keyword, resolve) {
            this.request({
                url: '/spu/model/options',
                data: {
                    category_id: this.categoryId,
                    brand_id: this.brandId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索部门*****************/
        searchDepartment(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'DEPARTMENT',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        }
    }
}
</script>